<template>
  <v-card class="max-height elevation-1" v-bind="$attrs">
    <v-card-text class="card-bg-1">
      <div class="caption grey--text text--darken-2">{{title}}</div>
      <div class="headline">
        <slot>
          {{ text }}
        </slot>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
    },
  }
</script>